"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discount = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
class Discount extends Base_1.Base {
    type = '';
    date = null;
    public = false;
    shipping = false;
    start = null;
    end = null;
    value = null;
    amount = null;
    reusable = false;
    used = false;
    code = '';
    title = '';
    description = '';
    author = '';
    author_id = '';
    user_id = '';
    manual = false;
    locked = false;
    universal = false;
    fn = '';
    constructor(data, olMap) {
        super('discounts', 18);
        (0, Common_1.setObjectProperties)(this, data, olMap, Discount);
    }
    calc(order) {
        switch (this.type) {
            case 'percentage':
                let discountable = order.subtotal || 0;
                if (this.shipping && order.shipping) {
                    discountable += order.shipping;
                }
                this.amount = (0, Common_1.round)(((this.value || 0) / 100) * discountable, 2);
                break;
            case 'flat':
                this.amount = this.value || 0;
                break;
            case 'logic':
                if (this.fn) {
                    let fn = Function('order', this.fn);
                    this.amount = fn(order);
                    if (isNaN(this.amount)) {
                        this.amount = 0;
                    }
                    else {
                        this.amount = (0, Common_1.round)(this.amount, 2);
                    }
                }
                break;
        }
    }
    toMinJSON(ignoreDocRef) {
        return this.toJSON();
    }
}
exports.Discount = Discount;
index_1.olm.discounts = (ref, map) => {
    return new Discount(ref, map);
};
